import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import GetCard from "../cards/GetCard";
function Projects() {
   return (
      <>
         <section className='projects-area content-area'>
            <Container>
               <Row className='g-4'>
                  <Col xl={4}>
                     <GetCard variant='profile'/>
                  </Col>
                  <Col xl={8}>
                     <Row className='g-4'>
                        <Col lg={12}>
                           <GetCard variant='project' showAll={true}/>
                        </Col>
                     </Row>
                  </Col>
               </Row>
            </Container>
         </section>
      </>
   );
 }
 export default Projects; 